<div *ngIf="isLoading" class="loading-overlay">
  <div class="loading-spinner">
    <div class="coins-container" aria-label="Cargando">
      <div *ngFor="let coin of coins; let i = index" 
           [class]="'coin-wrapper coin-' + (i + 1)">
        <img [src]="coin" class="coin-icon" alt="" />
      </div>
    </div>
    <div class="t-12-600-white blinking-text">Cargando...</div>
  </div>
</div>